import { render, staticRenderFns } from "./UserWorkStatus.vue?vue&type=template&id=24a93220"
import script from "./UserWorkStatus.vue?vue&type=script&lang=js"
export * from "./UserWorkStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports